import {accesToken} from '../auth/identityAuth';
import SnackbarService from './SnackbarService';
import HttpCallConfig from '../models/HttpCallConfig'

const snackbarService = SnackbarService.Instance;

class HttpService {
  private static instance: HttpService
  public success: string | undefined

  public constructor() {
    this.handleErrors = this.handleErrors.bind(this);
  }

  public static get Instance() {
    return this.instance || (this.instance = new this());
  }

  public async getsitecore(input?: string | Request, httpCallConfig?: HttpCallConfig) {
    const response = await fetch(input, {
      headers: {
      }
    })
    if (httpCallConfig) {
      if (httpCallConfig.successMessage) {
        this.handleConfirmation(response, httpCallConfig.successMessage)
      }
      if (httpCallConfig.successCallBack && response.ok) {
        httpCallConfig.successCallBack()
      }
      if (!httpCallConfig.disableErrorMessageing) {
        return this.handleErrors(response, httpCallConfig.enforceErrorPage)
      }
      else {
        return response
      }
    }
    return this.handleErrors(response)
  }
  public getAuthorizationToken() {
    return 'Bearer ' + accesToken;
  }

  public async get(input: string | Request, httpCallConfig?: HttpCallConfig) {
    const response = await fetch(input, {
        headers: {
            'Authorization': this.getAuthorizationToken(),
            'Content-Type': 'application/json',
            'Ocp-Apim-Subscription-Key': process.env.REACT_APP_API_KEY as string
        }
    })
      if (httpCallConfig) {
          if (httpCallConfig.successMessage) {
              this.handleConfirmation(response, httpCallConfig.successMessage)
          }
          if (httpCallConfig.successCallBack && response.ok) {
              httpCallConfig.successCallBack()
          }
          if (!httpCallConfig.disableErrorMessageing) {
              return this.handleErrors(response, httpCallConfig.enforceErrorPage)
          } else {
              return response
          }
      }
      return this.handleErrors(response)
  }

    public async delete(input: string | Request, httpCallConfig?: HttpCallConfig) {
        const response = await fetch(input, {
            headers: {
                'Authorization': this.getAuthorizationToken(),
                'Content-Type': 'application/json',
                'Ocp-Apim-Subscription-Key': process.env.REACT_APP_API_KEY as string
            },
            method: 'DELETE'
        });
        if (httpCallConfig) {
            if (httpCallConfig.successMessage) {
                this.handleConfirmation(response, httpCallConfig.successMessage)
            }
            if (httpCallConfig.successCallBack && response.ok) {
                httpCallConfig.successCallBack()
            }
            if (!httpCallConfig.disableErrorMessageing) {
                return this.handleErrors(response, httpCallConfig.enforceErrorPage)
            } else {
                return response
            }
        }
        return this.handleErrors(response)
    }

    public getCsv(input?: string | Request, httpCallConfig?: HttpCallConfig) {
        return fetch(input, {
            headers: {
                'Authorization': this.getAuthorizationToken(),
                'Content-Type': 'application/json',
                'Accept': 'text/csv',
                'Ocp-Apim-Subscription-Key': process.env.REACT_APP_API_KEY as string
            }
        }).then((response: Response) => httpCallConfig && httpCallConfig.disableErrorMessageing ? response : this.handleErrors(response))
    }

    public post(url: string | Request, data: any, httpCallConfig?: HttpCallConfig) {
        return fetch(url, {
            body: JSON.stringify(data),
            headers: {
        'Authorization': this.getAuthorizationToken(),
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_API_KEY as string
      },
      method: 'POST'
    })
      .then(this.handleErrors)
      .then((response: Response) => { if (httpCallConfig && httpCallConfig.successMessage) { this.handleConfirmation(response, httpCallConfig.successMessage) } return response })
      .then((response: Response) => { if (httpCallConfig && httpCallConfig.successCallBack && response.ok) { httpCallConfig.successCallBack() } return response })
  }

  public put(url: string | Request, data: any, httpCallConfig?: HttpCallConfig) {
    return fetch(url, {
      body: JSON.stringify(data),
      headers: {
        'Authorization': this.getAuthorizationToken(),
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_API_KEY as string
      },
      method: 'PUT'
    })
      .then(this.handleErrors)
      .then((response: Response) => { if (httpCallConfig && httpCallConfig.successMessage) { this.handleConfirmation(response, httpCallConfig.successMessage) } return response })
      .then((response: Response) => { if (httpCallConfig && httpCallConfig.successCallBack && response.ok) { httpCallConfig.successCallBack() } return response })
  }

  public handleConfirmation(response: Response, successMessage: string) {
    if (response.ok) {
      snackbarService.showSnackbar('success', successMessage);
    }
  }

  public handleErrors(response: Response, enforcedErrorPage?: boolean) {
    if (!response.ok) {
      if (response.status === 404 || response.status === 401 || response.status === 403 || enforcedErrorPage) {
        window.location.assign(process.env.REACT_APP_APPLICATION_ROOT as string + 'error/' + response.status + '/' + encodeURI(response.statusText))
      }
      else {
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          response.json().then(body => (body && body.error ? snackbarService.showSnackbar('error', body.error) : snackbarService.showSnackbar('error', response.statusText)));
        }
        else {
          snackbarService.showSnackbar('error', response.statusText)
        }
      }
    }
    return response;
  }
}

export default HttpService



// WEBPACK FOOTER //
// ./src/modules/core/services/HttpService.tsx